const audioPlayer = {
    namespaced: true,
    state: {
        currentTrackId: null,
        trigger: null,
        destroy: null,
        isPlaying: false,
        suspend: false,
        provider: null,
        episodeTitle: null,
        episodePermlink: null,
        episodeUrl: null,
        podcastPermlink: null,
        podcastTitle: null,
        soundcloudInstance: null,
        soundcloudUrl: null,
        artist: null,
    },

    mutations: {
        setIsPlaying(state, payload) {
            state.isPlaying = payload;
        },
        setEpisodeTitle(state, payload) {
            state.episodeTitle = payload;
        },
        setEpisodePermlink(state, payload) {
            state.episodePermlink = payload;
        },
        setEpisodeUrl(state, payload) {
            state.episodeUrl = payload;
        },
        setProvider(state, payload) {
            state.provider = payload;
        },
        setPodcastPermlink(state, payload) {
            state.podcastPermlink = payload;
        },
        setPodcastTitle(state, payload) {
            state.podcastTitle = payload;
        },
        setTrigger(state, payload) {
            state.trigger = payload;
        },
        setCurrentTrackId(state, payload) {
            state.currentTrack = payload;
        },
        setSoundcloudInstance(state, payload) {
            state.soundcloudInstance = payload;
        },
        setDestroy(state, payload) {
            state.destroy = payload;
        },
        setSoundcloudUrl(state, payload) {
            state.soundcloudUrl = payload;
        },
        setSuspend(state, payload) {
            state.suspend = payload;
        },
        setArtist(state, payload) {
            state.artist = payload;
        }
    },

    actions: {
        trigger({commit}) {
            commit('setTrigger', Date.now());
        },
        destroy({commit}) {
            commit('setDestroy', Date.now());
        },
        suspend({commit}) {
            commit('setSuspend', true);
        },
        resetSuspend({commit}) {
            commit('setSuspend', false);
        }
    },

    getters: {
        getAudioPlayerData: state => state.audioPlayerData,
        getProvider: state => state.provider,
        getEpisodeTitle: state => state.episodeTitle,
        getEpisodePermlink: state => state.episodePermlink,
        getEpisodeUrl: state => state.episodeUrl,
        getPodcastTitle: state => state.podcastTitle,
        getPodcastPermlink: state => state.podcastPermlink,
        getAudioPlayerIsPlaying: state => state.isPlaying,
        getTrigger: state => state.trigger,
        getDestroy: state => state.destroy,
        getCurrentTrackId: state => state.currentTrackId,
        getSoundcloudInstance: state => state.soundcloudInstance,
        getSoundcloudUrl: state => state.soundcloudUrl,
        getSuspend: state => state.suspend,
        getArtist: state => state.artist
    }
}

export default audioPlayer;